
import { computed, defineComponent, ref } from 'vue';
import Modal from '@/components/Modal.vue';
import ClaimMediaGalleryViewer from '@/components/ClaimMediaGalleryViewer.vue';
import { IClaimMedia } from '@/types';

export default defineComponent({
  name: 'ClaimMediaGallery',
  components: {
    ClaimMediaGalleryViewer,
    Modal,
  },
  props: {
    media: Array,
    isSharable: {
      // flag to display the share with vendor checkbox
      type: Boolean,
      default: true,
    },
  },
  emits: ['toggleShare'],
  setup(props, { emit }) {
    const pivotPoint = ref<number>(4);
    const expandIndicator = computed<number>(() =>
      props.media ? props.media.length - 1 - pivotPoint.value : 0
    );
    const anyPrivate = computed<boolean>(() => {
      const mediaArr =
        props.media && props.media.length > pivotPoint.value
          ? props.media.slice(pivotPoint.value)
          : [];
      return mediaArr.some((media: any) => media.isPrivate === true);
    });

    const isModalVisible = ref<boolean>(false);

    const currentMedia = ref<IClaimMedia | null>(null);

    const displayOverlay = (index: number): boolean =>
      expandIndicator.value > 0 && index === pivotPoint.value;

    const expandMedia = () => {
      pivotPoint.value = props.media ? props.media?.length + 1 : 4;
    };

    const onCloseModal = () => {
      isModalVisible.value = false;
    };

    const selectMedia = (media: IClaimMedia) => {
      currentMedia.value = media;
      isModalVisible.value = true;
    };

    const toggleShare = (media: IClaimMedia) => {
      // have to define by using camelCase, due to the browser warning
      // [Vue warn]: Extraneous non-emits event listeners (toggleShare) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.
      // eslint-disable-next-line vue/custom-event-name-casing
      emit('toggleShare', media);
    };

    return {
      pivotPoint,
      displayOverlay,
      expandIndicator,
      expandMedia,
      currentMedia,
      selectMedia,
      isModalVisible,
      onCloseModal,
      toggleShare,
      anyPrivate,
    };
  },
});
